var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-list-item"},[_c('div',{staticClass:"status"},[_c('MarkingStatusBadge',{attrs:{"status":_vm.status}})],1),_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm._f("parseDate")(_vm.timestamp))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }